import { t } from "@lingui/core/macro";
import { api } from "@/lib/api-client";
import {
  NotificationSwitchRow,
  renderChannelIcons,
} from "@/Components/AppointmentModal/components/NotificationSettingsSwitchList";
import { findEnabledSetting } from "@/features/notification-settings/utils/findEnabledSetting";

export const NoShowNotificationSwitch = ({
  isSelected,
  onValueChange,
  selectedServices,
  locationId,
}: {
  isSelected: boolean;
  onValueChange: (enabled: boolean) => void;
  selectedServices?: { serviceId: number | string }[];
  locationId?: number | null;
}) => {
  const { data: notificationSettings } =
    api.notification.useGetNotificationSettings();
  const { data: notificationChannels } =
    api.notification.useGetNotificationChannels();

  const noShowSetting = findEnabledSetting(notificationSettings?.settings, {
    event: "noShow",
  });

  return (
    <NotificationSwitchRow
      label={t`Pošlji obvestila`}
      icons={renderChannelIcons(
        noShowSetting,
        selectedServices ?? [],
        locationId ?? null,
        notificationChannels,
      )}
      isSelected={isSelected}
      onValueChange={onValueChange}
    />
  );
};
